
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Major overhaul of the Figma Sticker Sheet, new Reusable `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@pxblue/angular-auth-workflow"
      }}>{`Authentication Workflow`}</a>{` for Angular, `}<a parentName="p" {...{
        "href": "https://github.com/pxblue/react-cli-templates/tree/master"
      }}>{`CLI templates`}</a>{` for React projects, and documentation site improvements.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;